// @ts-nocheck
import {EntityTypeModel} from '/ui/components/entitypicker/datasource/datamodel';
import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';
import EntityIcon from '/ui/components/entitypicker/icons/entity.svg';
import EventCircleIcon from '/ui/icons/inline/event-circle.svg';
import EventIcon from '/ui/icons/inline/event.svg';
import LocationCircleIcon from '/ui/icons/inline/location-circle.svg';
import LocationIcon from '/ui/icons/inline/location.svg';
import PersonCircleIcon from '/ui/icons/inline/person-circle.svg';
import PersonIcon from '/ui/icons/inline/person.svg';


/**
 * @param {number | EntityTypeModel} entityType
 * @returns {React.ReactElement}
 */
export const getEntityIcon = entityType => {
  if (entityType === null || entityType === undefined) {
    return <EntityIcon />;
  } else {
    const id = typeof entityType.id === 'number' ? entityType.id : entityType;
    switch (id) {
      case 0:
      case 2:
      case 4:
      case 5:
      case 6:
        return <LocationIcon />;
      case 1:
        return <PersonIcon />;
      case 3:
        return <EventIcon />;
      default:
        if (entityType === undefined || entityType.label) {
          return <div className={styles.customIcon}>
            {entityType ? entityType.label[0] : '?'}
          </div>;
        } else {
          return <EntityIcon />;
        }
    }
  }
};

/**
 * @param {number | EntityTypeModel} entityType
 * @returns {React.ReactElement}
 */
export const getEntitySectionIcon = entityType => {
  if (entityType === null || entityType === undefined) {
    return <EntityIcon />;
  } else {
    const id = typeof entityType.id === 'number' ? entityType.id : entityType;
    switch (id) {
      case 0:
      case 2:
      case 4:
      case 5:
      case 6:
        return <LocationCircleIcon />;
      case 1:
        return <PersonCircleIcon />;
      case 3:
        return <EventCircleIcon />;
      default:
        return <div className={styles.customIcon}>
          {entityType ? entityType.label[0] : '?'}
        </div>;
    }
  }
};
